import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ConversionTaskDetailRBAC = {
  pageID: '70c5ec0301462363117d98442f73ab45',
  elementID: {
    ViewDetail: '87df29f81504789a170af6b8753e9dc9',
    BtnAssignPic: 'bd36746f1027b70d4bbf1adefab04adc',
    BtnCompleteTask: '919be0788aebb51151d2e261df438cc5',
  },
} as const

export const useRBACConversionTaskDetail = createUseRBAC(ConversionTaskDetailRBAC.elementID)

export type UseRBACConversionTaskDetailType = ReturnType<typeof useRBACConversionTaskDetail>
